let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4x0L6")).then(() => parcelRequire('fXYLR'));